import {Lead, Slot, Text, Trail} from '@yandex-delivery/blocks'
import {Image} from '@yandex-delivery/blocks/image'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import {renderWidget} from '..'
import type {HeaderWidgetProps as Props} from '../types'

export const HeaderWidget = ({config: {image, title, trail}}: Props): React.ReactElement => (
  <Slot pr="xs" size="l">
    {image && (
      <Lead>
        <Image alt="" height={parseFloat(spacing(5))} src={tagToUrl(image.image_tag)} />
      </Lead>
    )}
    <Text>{title.items.map(renderWidget)}</Text>
    {trail && <Trail>{renderWidget(trail)}</Trail>}
  </Slot>
)
